import type { AppIcon } from "@/components/appIcons";
import { FilterSelectTriggerIcon } from "@/components/ui/filter-select-trigger-icon";
import { SelectTriggerAction } from "@/components/ui/select-trigger-action";
import { cn } from "@/lib/utils";

interface FilterSelectTriggerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  icon: AppIcon;
  selectedIconUrl?: string;
  selectedIcon?: AppIcon;
  selectedLabel: string | null | undefined;
  selectedLabelPrefix?: string;
  placeholder: string;
  value: string | null;
  clearable: boolean;
  intent: "filter" | "sort";
  isFullWidth: boolean;
  showTriggerIcon: boolean;
  triggerClassName?: string;
  triggerLabelClassName?: string;
  onClear: () => void;
}

export function FilterSelectTrigger({
  open,
  setOpen,
  icon,
  selectedIconUrl,
  selectedIcon,
  selectedLabel,
  selectedLabelPrefix,
  placeholder,
  value,
  clearable,
  intent,
  isFullWidth,
  showTriggerIcon,
  triggerClassName,
  triggerLabelClassName,
  onClear,
}: FilterSelectTriggerProps) {
  const stateClass =
    intent === "sort"
      ? "bg-background/60 border-border/80 text-foreground hover:border-border sm:bg-secondary/50 sm:border-border"
      : value
        ? "bg-primary/10 border-primary/30 text-foreground"
        : "bg-secondary/50 border-border text-muted-foreground hover:border-border/80";

  return (
    <button
      type="button"
      onClick={() => setOpen(!open)}
      className={cn(
        "flex items-center border rounded-md text-sm cursor-pointer transition-all focus:outline-none focus:ring-1 focus:ring-primary",
        isFullWidth ? "w-full min-h-12 gap-3 px-3 py-2.5" : "gap-1.5 pl-2.5 pr-2 h-11 sm:h-10",
        stateClass,
        triggerClassName,
      )}
    >
      <FilterSelectTriggerIcon
        iconUrl={selectedIconUrl}
        optionIcon={selectedIcon}
        fallbackIcon={icon}
        showFallback={showTriggerIcon}
      />
      <span className={cn("min-w-0 flex-1 truncate text-left", triggerLabelClassName)}>
        {selectedLabel && selectedLabelPrefix
          ? `${selectedLabelPrefix}: ${selectedLabel}`
          : (selectedLabel ?? placeholder)}
      </span>
      <SelectTriggerAction
        clearable={Boolean(value) && clearable}
        onClear={(event) => {
          event.stopPropagation();
          onClear();
        }}
      />
    </button>
  );
}
